import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Select, DatePicker, Modal } from 'antd';
import { Btn } from '../components/Widgets';
import moment from 'moment';
import './SysLog.less';

const { RangePicker } = DatePicker;
const Option = Select.Option;

class SysLog extends PureComponent {
  constructor() {
    super();
    this.state = {
      serverName: 'iwork',
      startDate: moment(),
      endDate: moment(),
      logLevel: 'info'
    };
  }
  render() {
    const { intl, dispatch } = this.props;
    return (
      <div className="sys-log-download">
        <div className="form-area">
          <div className="form-item">
            <span className="form-label"><FormattedMessage id="sys_log_server_select" /> :</span>
            <span>
              <Select
                defaultValue="iwork"
                value={this.state.serverName}
                onChange={value => {
                  this.setState({ serverName: value });
                }}
              >
                <Option value="iwork">iwork</Option>
                <Option value="notice">notice</Option>
                <Option value="meeting">meeting</Option>
                <Option value="socket">socket</Option>
                <Option value="syncmeeting">syncmeeting</Option>
                <Option value="syncuser">syncuser</Option>
              </Select>
            </span>
          </div>
          <div className="form-item">
            <span className="form-label"><FormattedMessage id="sys_log_search_date" /> :</span>
            <span>
                <RangePicker
                  defaultValue={[moment(this.state.startDate), moment(this.state.endDate)]}
                  format={'YYYY/MM/DD'}
                  onChange={(dates, dateStrs)=>{
                    if(dates && dates.length == 2) {
                      this.setState({
                        startDate: dates[0],
                        endDate: dates[1],
                      });
                    } else {
                      this.setState({
                        startDate: null,
                        endDate: null,
                      });
                    }
                  }}
                />
              </span>
          </div>
          <div className="form-item">
            <span className="form-label"><FormattedMessage id="sys_log_level" /> :</span>
            <span>
              <Select
                defaultValue="info"
                value={this.state.logLevel}
                onChange={value => {
                  this.setState({ logLevel: value });
                }}
              >
                <Option value="info">INFO</Option>
                <Option value="error">ERROR</Option>
                <Option value="warn">WARN</Option>
              </Select>
            </span>
          </div>
          <div className="operate_btn_div">
            <Btn
              primary
              onClick={() => {
                 if(!this.state.startDate || !this.state.endDate){
                   Modal.error({ content: intl.formatMessage({ id: 'sys_log_search_date_empty' }) });
                 } else {
                   dispatch({ type: 'sysParam/downloadLog', payload: this.state});
                 }
              }}
            >
              <FormattedMessage id="sys_log_download" />
            </Btn>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => state.i18n;

export default connect(mapStateToProps)(injectIntl(SysLog));



// WEBPACK FOOTER //
// ./src/routes/SysLog.js